import { $disclosureApi } from '../../index';
import { DisclosurePayload, DisclosureResponse } from './types';
import { AxiosResponse } from 'axios';

export default class Disclosures {
	static async getData(data: DisclosurePayload): Promise<AxiosResponse<DisclosureResponse>> {
		return $disclosureApi.post(``, data);
	}
}
